module.exports = __webpack_public_path__ + "img/wordwars-1.5b9f6d34.jpg";